//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: "maternal_form_list",
        data(){
            return{
                a:1,
                listData: [
                    {name:'母亲入住评估单',id:1},
                    {name:'产妇膳食记录表',id:2},
                    {name:'产妇康复护理评估记录单',id:3},
                    {name:'产妇每日生理护理记录表',id:4}
                ],
                // id: this.$route.query.id,
                // tabVal: this.$route.query.tabVal
            }
        },
        methods:{
            //填写表单
            
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d + ' '+ h + ':' + minute + ':' + second
            },
            //查看表格
            writeForm(type){
                console.info(type)
                if(type==1){
                     this.$router.push({
                        path:'/maternal_form_a',
                        query: {
                            type:this.a
                        }
                    })
                }
                if(type==2){
                     this.$router.push({
                        path:'/maternal_form_b',
                        query: {
                            type:this.a
                        }
                    })
                }
                if(type==3){
                     this.$router.push({
                        path:'/maternal_form_c',
                        query: {
                            type:this.a
                        }
                    })
                }
                if(type==4){
                    this.$router.push({
                        path:'/maternal_form_d',
                        query: {
                            type:this.a
                        }
                    })
                }
                // let marternal_id = this.$route.query.id
                // this.$router.push({
                //     path: './detail_other_form',
                //     query: {
                //         id: marternal_id,
                //         form_id: form_id
                //     }
                // })
            }
        },
        created (){
            if(this.$route.query.a){
                this.a = this.$route.query.a
            }
        },
        mounted (){
            
        }
    }



// WEBPACK FOOTER //
// ./src/components/maternal_form_list.vue